import type { CheckoutStep } from '../hooks/useHashStep';

interface StepIndicatorProps {
  currentStep: CheckoutStep;
  onStepClick: (step: CheckoutStep) => void;
  canNavigateTo: (step: CheckoutStep) => boolean;
}

const STEPS: { id: CheckoutStep; label: string }[] = [
  { id: 'cart', label: 'Cart' },
  { id: 'shipping', label: 'Shipping' },
  { id: 'payment', label: 'Payment' },
];

export default function StepIndicator({ currentStep, onStepClick, canNavigateTo }: StepIndicatorProps) {
  const currentIdx = STEPS.findIndex((s) => s.id === currentStep);

  return (
    <nav className="step-indicator" aria-label="Checkout progress">
      {STEPS.map((step, idx) => {
        const isActive = step.id === currentStep;
        const isCompleted = idx < currentIdx;
        const canClick = canNavigateTo(step.id);

        return (
          <div key={step.id} className="step-indicator-item">
            {idx > 0 && <div className={`step-indicator-line${isCompleted || isActive ? ' step-indicator-line--active' : ''}`} />}
            <button
              className={`step-indicator-dot${isActive ? ' step-indicator-dot--active' : ''}${isCompleted ? ' step-indicator-dot--completed' : ''}`}
              onClick={() => canClick && onStepClick(step.id)}
              disabled={!canClick}
              aria-current={isActive ? 'step' : undefined}
              type="button"
            >
              {isCompleted ? '\u2713' : idx + 1}
            </button>
            <span className={`step-indicator-label${isActive ? ' step-indicator-label--active' : ''}`}>
              {step.label}
            </span>
          </div>
        );
      })}
    </nav>
  );
}
